import React, { useEffect, useState } from 'react';
import Service from './Service';
import Spinner from '../../Shared/Spinner/Spinner';

const Services = () => {

    const [services, setServices] = useState([])

    useEffect(() => {

        const data = [
            {
                _key: 1,
                name: "Custom CRM Development",
                price: "15000",
                description: "Customized CRM solutions for customers, vendors, orders and business management.",
                img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            },
            {
                _key: 2,
                name: "Website Development",
                price: "10000",
                description: "Modern responsive websites for startups and businesses.",
                img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            },
            {
                _key: 3,
                name: "Software Solutions",
                price: "25000",
                description: "Business software and automation solutions according to company needs.",
                img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            }
        ];

        setServices(data);

    }, [])

    return (
        <section id="services" className="services">
            <h4 className="miniTitle text-center">SERVICES</h4>

            <div className="text-center">
                <h5 className="text-center sectionTitle">
                    PROVIDE AWESOME SERVICE
                </h5>
            </div>

            {services.length === 0 &&
                <div className="spinner text-center">
                    <Spinner/>
                </div>
            }

            <div className="row mt-4 container mx-auto justify-content-center">
                {
                    services?.map((service, id) =>
                        <Service
                            key={service._key + id}
                            service={service}
                        />
                    )
                }
            </div>
        </section>
    );
};

export default Services;